module.exports = __webpack_public_path__ + "img/filter.9a272007.svg";